import { createApp } from 'vue'
import { createI18n } from 'vue-i18n'
import App from './App.vue'
import './style.css'

// Import locale files
import enLocale from './locales/en.json'
import thLocale from './locales/th.json'

// Get saved language or detect from browser
const getSavedLanguage = (): string => {
  const saved = localStorage.getItem('pdf-tools-language')
  if (saved && (saved === 'en' || saved === 'th')) {
    return saved
  }

  // Detect from browser
  const browserLang = navigator.language.toLowerCase()
  if (browserLang.startsWith('th')) {
    return 'th'
  }

  return 'en'
}

// Create i18n instance
const i18n = createI18n({
  legacy: false,
  locale: getSavedLanguage(),
  fallbackLocale: 'en',
  messages: {
    en: enLocale,
    th: thLocale,
  },
})

// Create and mount app
const app = createApp(App)
app.use(i18n)
app.mount('#app')
